/**
 * DemoBanner
 *
 * Banner sutil arriba del layout cuando estamos en modo demo (mock mode).
 * Aclara que los datos no persisten al refrescar — para evitar que un
 * cliente o inversor se confunda cuando crea algo y se le borra.
 *
 * Se puede cerrar (localStorage recuerda si ya lo cerraron en esta sesión).
 */

import { useState } from "react";
import { Info, X } from "lucide-react";

const STORAGE_KEY = "deenex-demo-banner-dismissed";

export default function DemoBanner() {
    const isMockMode = import.meta.env.VITE_MOCK_MODE === "true";

    const [dismissed, setDismissed] = useState<boolean>(() => {
        try {
            return localStorage.getItem(STORAGE_KEY) === "1";
        } catch {
            return false;
        }
    });

    if (!isMockMode || dismissed) return null;

    const handleDismiss = () => {
        try {
            localStorage.setItem(STORAGE_KEY, "1");
        } catch {
            /* ignore */
        }
        setDismissed(true);
    };

    return (
        <div className="bg-gradient-to-r from-violet-500/95 via-violet-600/95 to-fuchsia-600/95 text-white text-xs px-4 py-2 flex items-center justify-center gap-2 relative z-30 shadow-sm">
            <Info size={13} className="flex-shrink-0 opacity-90" />
            <span className="font-medium">
                Modo demo —
            </span>
            <span className="opacity-90 hidden sm:inline">
                los datos que crees se borran al refrescar la página. Para
                guardar todo, conectá el backend real.
            </span>
            <span className="opacity-90 sm:hidden">
                datos no persisten al refrescar.
            </span>
            <button
                onClick={handleDismiss}
                className="ml-2 p-1 rounded-md hover:bg-white/20 transition-colors flex-shrink-0"
                aria-label="Cerrar banner"
            >
                <X size={12} />
            </button>
        </div>
    );
}
